import { useEffect } from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/feature/PageHero";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPage() {
  useEffect(() => {
    document.title = "常见问题 · 妖精漫画堂 韩国妖精漫画奇幻异世界在线看";
  }, []);

  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="常见问题"
        description="关于题材收录、更新进度与反馈渠道的常见疑问，我们都整理在这里了。找不到答案？欢迎随时联系我们。"
        image="https://readdy.ai/api/search-image?query=glowing%20question%20marks%20floating%20among%20magical%20fairy%20lights%20in%20a%20soft%20fantasy%20background%2C%20stylized%20digital%20illustration%2C%20emerald%20and%20gold%20palette&width=1600&height=600&seq=faq-banner&orientation=landscape"
        crumbs={[
          { label: "首页", to: "/" },
          { label: "常见问题" },
        ]}
      />

      <section className="py-12 md:py-16">
        <div className="container-site grid gap-8 lg:grid-cols-[1fr_290px]">
          <div>
            <FaqAccordion items={faqs} />
          </div>
          <aside className="space-y-6">
            <div className="card p-5">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-message-3-line text-lg" />
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-900">还有其他疑问？</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                如果这里没有解答你的问题，欢迎通过联系方式告诉我们，我们会尽快回复。
              </p>
              <Link to="/contact" className="btn btn-primary mt-4 w-full">
                联系我们
              </Link>
            </div>
            <div className="rounded-lg bg-primary-50 p-5">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-sparkling-2-fill text-lg" />
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-900">想了解更多题材？</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">从三大世界观分类出发，探索更多妖精漫画作品。</p>
              <div className="mt-4 flex flex-wrap gap-2">
                <Link to="/category/otherworld" className="chip cursor-pointer transition-colors hover:bg-secondary-200">异世界穿越</Link>
                <Link to="/category/elf" className="chip cursor-pointer transition-colors hover:bg-secondary-200">精灵契约</Link>
                <Link to="/category/myth" className="chip cursor-pointer transition-colors hover:bg-secondary-200">妖怪神话</Link>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}